export default __webpack_public_path__ + "maps-examples-dds-circle-layer-960-01bdda251335e6eb8c4e16a851e56e31.png";